export var COMMIT_TYPE = {
    ValidationCollector: 'setValidationCollector',
};
